export const ANSWERS_DATA = {
  //loc06
  q18: {
    answer: "1838",

    next: {
      route: "/info",
      DateVal: "quiz18",
      titImgClass: "messageTit01",
    },
  },
  //sbt07
  q25: {
    answer: "1747",

    next: {
      route: "/info",
      DateVal: "quiz25",
      titImgClass: "messageTit01",
    },
  },
  //lck05
  q30: {
    answer: "0915",

    next: {
      route: "/info",
      DateVal: "quiz30",
      titImgClass: "messageTit01",
    },
  },
  //clu06
  q31: {
    answer: "1057",

    next: {
      route: "/info",
      DateVal: "quiz31",
      titImgClass: "messageTit01",
    },
  },
  end_q1: {
    answer: "3",

    next: {
      route: "/quiz",
      answerData: "end_q2",
      DateVal: "end_q2",
      titImgClass: "finalQuizTit22",
    },
  },
  end_q2: {
    answer: "2",

    next: {
      route: "/quiz",
      answerData: "end_q3",
      DateVal: "end_q3",
      titImgClass: "finalQuizTit",
    },
  },
  end_q3: {
    answer: "1",

    next: {
      route: "/quiz",
      answerData: "end_q4",
      DateVal: "end_q4",
      titImgClass: "finalQuizTit",
    },
  },
  end_q4: {
    answer: "2",

    next: {
      route: "/quiz",
      answerData: "end_q5",
      DateVal: "end_q5",
      titImgClass: "finalQuizTit",
    },
  },
  end_q5: {
    answer: "3",

    next: {
      route: "/quiz",
      answerData: "end_q6",
      DateVal: "end_q6",
      titImgClass: "finalQuizTit",
    },
  },
  end_q6: {
    answer: "2",

    next: {
      route: "/info",
      DateVal: "end_q_finish",
      titImgClass: "finalQuizTit",
    },
  },
};
